import { Component, Input, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { ToastrService } from 'ngx-toastr';
import { Common } from 'src/app/common';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { FamilyMemberRegistrationComponent } from '../family-member-registration/family-member-registration.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-ehr-report-modal',
  templateUrl: './ehr-report-modal.component.html',
  styleUrls: ['./ehr-report-modal.component.css']
})
export class EhrReportModalComponent implements OnInit {
  @Input() patientId:any
  ehrFormRpt:FormGroup;lstbenHstry = [];benHistory = []; benHistoryRef = [];selectedData:any;ehrhistory:any=[];
  profile_photo: any; roleId:any;
  isPrintOnlyUpdated: boolean;
  vitalList: any[];
  is_self: boolean = true;ehrBack:boolean = false;
  documentHistory: any=[];
  ehrButton = true;
  docData: any;
  isNDHMEnable: boolean = false;
  constructor(private formBuilder:FormBuilder,
    private registrationService: RegistrationService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private authSvc:AuthenticationService,
    public activeModal: NgbActiveModal,
    private active :ActivatedRoute
    ) { 
    }

  ngOnInit(): void {
    this.getFeaturePermission();
    this.roleId = this.authSvc.roleId;
    this.inItFormControls();
    if( sessionStorage.getItem('is_self_ehr')==='1'){
      this.getBenHistoryDetails(this.patientId);
    } else {
      this.getMemBenHistoryDetails(this.patientId);
    }
    if(sessionStorage.getItem('DoctorDetails')!=null && sessionStorage.getItem('DoctorDetails')!='' && sessionStorage.getItem('DoctorDetails')!=undefined){
   this.docData = JSON.parse(sessionStorage.getItem('DoctorDetails'));
    }
   
}
 getFeaturePermission() {
    var featureList: any = JSON.parse(localStorage.getItem('featuresList'));
    for (let i = 0; i < featureList.length; i++) {
      if (featureList[i].feature_id.feature_name == "isNDHMEnable") {
        this.isNDHMEnable = featureList[i].patient;
      }
      //isEnableEHR

    }

  }
btnClick= function () {
  this.router.navigateByUrl('/home/patientList');
};

  inItFormControls(){
    this.ehrFormRpt = this.formBuilder.group({
      abhaid: [{ value: '', disabled: true }],
  photo_path: [''],
  state: [{ value: '', disabled: true }],
  district: [{ value: '', disabled: true }],
  block: [''],
  Village: [''],
  centername: [{ value: '', disabled: true }],
  name: [{ value: '', disabled: true }],
  gender: [{ value: '', disabled: true }],
  age: [{ value: '', disabled: true }],
  mobile: [{ value: '', disabled: true }],
  maritalStatus: ['']
      // isPrintOnlyUpdated:[false]

    });
  }
  // getBenHistoryDetails(id) {
  //   this.lstbenHstry = [];
  //   this.registrationService.getDataById('findbybeneficiaryid?beneficiaryId=', id).subscribe(res => {
      
  //     if (res.data.length > 0) {
  //       res.data.forEach((item,i) => {
  //         item.vital_history['visitdate']=item.visit_date;
  //       });
  //       this.benHistory = res.data;
  //       Common.loadDataTable(this.benHistory, '#tablevitals');
  //     }
  //     // this.benHistoryRef = res.data[0];
  //     this.selectedData=res.data[0]
  //     setTimeout(() => {
  //       this.bindData();
  //     }, 2000);
     
  //     res.data.forEach(e => {
  //       let temp = e.beneficiary_visit_files;
  //       let resDgns = e.diagnosis.provisionalDiagnosis;
  //       var doc_id = e.doctor_id.id;
  //       //Object.keys(e)
  //       if (Object.keys(e).includes('prescribed_medications')) {
  //         e.prescribed_medications['doc_id'] = doc_id;
  //       }
  //       // let isStr = (typeof e.diagnosis?.provisionalDiagnois == 'string');
  //       if (resDgns.length > 0) {
  //         resDgns.forEach(rd => {
  //           this.lstbenHstry.push({ visit_date: e.visit_date, docCmnt: e.advice.doctorComment, dgns: rd?.diagnosis_name, document_path: temp });
  //         });
  //       }
  //     });
  //   }, err => { this.toastr.error(err) });
  // }
  getBenHistoryDetails(id:any) {
    this.lstbenHstry = [];
    this.registrationService.getehr(id).subscribe(res => {
      // if (res.data.length > 0) {
      //   res.data.forEach((item,i) => {
      //     item.vital_history['visitdate']=item.visit_date;
      //   });
      //   this.benHistory = res.data;
      //   Common.loadDataTable(this.benHistory, '#tablevitals');
      // }
      // this.benHistoryRef = res.data[0];
      // this.selectedData=res.ehrReport;
      // this.profile_photo=res.data[0].photo_path;
      this.selectedData=res.data.ehrReport.length>0 ? res.data.ehrReport[0] : this.getUserData(id);
      this.profile_photo= res.data.ehrReport.length>0 ?res.data.ehrReport[0].photo_path :' ';
      // let ehrhistory=[];
      // res.data.ehrReport.map(resp=>{
      //   if(this.docData){
      //           if(resp.doctor_id==this.docData.id){
      //   ehrhistory.push(resp);
      //  }
      //   }

      // })
      this.ehrhistory=res.data.ehrReport;
      // this.ehrhistory=ehrhistory;
      // console.log(this.ehrhistory)
      // this.ehrhistory.map((res=>{
      //  res.past_history= res.past_history.toUpperCase(); 
      //  res.allergy= res.allergy.toUpperCase(); 
      // }
      //   ))
     
      let documentHistory=[];
      res.data.documentReport.map(resp=>{
        if(this.docData){
       if(resp.doctor_id==this.docData.id){
        documentHistory.push(resp);
       }
      }
      })
      this.documentHistory=documentHistory;
      // this.ehrhistory=ehrhistory;
      //  this.ehrhistory.forEach((res=>{
      //  res.prescription=res.data.poc_file_path;
      //  }
      //   ))
        this.vitalList=res.data.vitalReport;
      this.vitalList.map((res=>{
        let hgt = (res.height/100)*(res.height/100);
        let bmi = res.weight/hgt;
        if(bmi<18.5){
        res.bmi='Under Weight';
        } if(bmi>=18.5 && bmi<=24.9){
          res.bmi='Normal';
        } if(bmi>=25 && bmi<=29.9){
          res.bmi='Over Weight';
        }if(bmi>=30.0){
          res.bmi='Very Over Weight'
        }
      }
        ))
      //Common.loadDataTable(this.ehrhistory, '#tablevitals');
      setTimeout(() => {
        this.bindData();
      }, 2000);
      // res.data.forEach(e => {
      //   let temp = e.beneficiary_visit_files;
      //   let resDgns = e.diagnosis.provisionalDiagnosis;
      //   var doc_id = e.doctor_id.id;
      //   //Object.keys(e)
      //   if (Object.keys(e).includes('prescribed_medications')) {
      //     e.prescribed_medications['doc_id'] = doc_id;
      //   }
      //   // let isStr = (typeof e.diagnosis?.provisionalDiagnois == 'string');
      //   if (resDgns.length > 0) {
      //     resDgns.forEach(rd => {
      //       this.lstbenHstry.push({ visit_date: e.visit_date, docCmnt: e.advice.doctorComment, dgns: rd?.diagnosis_name, document_path: temp });
      //     });
      //   }
      // });
    }, err => { this.toastr.error(err) });

  //  this.getBenVitalDetails(id);
  }
  //Get New lines added for vitals New API Integration 09-04-2022
  getBenVitalDetails(id) {
   
   this.vitalList=[];
    this.registrationService.getVitals(id).subscribe(res => {
      
      // if (res.data.length > 0) {
      //   res.data.forEach((item,i) => {
      //     item.vital_history['visitdate']=item.visit_date;
      //   });
      //   this.benHistory = res.data;
      //   Common.loadDataTable(this.benHistory, '#tablevitals');
      // }
      // this.benHistoryRef = res.data[0];
      this.vitalList=res.data;
      this.vitalList.map((res=>{
        let hgt = (res.height/100)*(res.height/100);
        let bmi = res.weight/hgt;
        if(bmi<18.5){
        res.bmi='Under Weight';
        } if(bmi>=18.5 && bmi<=24.9){
          res.bmi='Normal';
        } if(bmi>=25 && bmi<=29.9){
          res.bmi='Over Weight';
        }if(bmi>=30.0){
          res.bmi='Very Over Weight'
        }
      }
        ))
      //Common.loadDataTable(this.ehrhistory, '#tablevitals');
      setTimeout(() => {
        this.bindData();
      }, 2000);
     
      // res.data.forEach(e => {
      //   let temp = e.beneficiary_visit_files;
      //   let resDgns = e.diagnosis.provisionalDiagnosis;
      //   var doc_id = e.doctor_id.id;
      //   //Object.keys(e)
      //   if (Object.keys(e).includes('prescribed_medications')) {
      //     e.prescribed_medications['doc_id'] = doc_id;
      //   }
      //   // let isStr = (typeof e.diagnosis?.provisionalDiagnois == 'string');
      //   if (resDgns.length > 0) {
      //     resDgns.forEach(rd => {
      //       this.lstbenHstry.push({ visit_date: e.visit_date, docCmnt: e.advice.doctorComment, dgns: rd?.diagnosis_name, document_path: temp });
      //     });
      //   }
      // });
    }, err => { this.toastr.error(err) });
  }
  //End of New line Vitals API Integration 

  getMemBenHistoryDetails(id) {
    this.lstbenHstry = [];
    this.registrationService.getmemberehr(id).subscribe(res => {
      // if (res.data.length > 0) {
      //   res.data.forEach((item,i) => {
      //     item.vital_history['visitdate']=item.visit_date;
      //   });
      //   this.benHistory = res.data;
      //   Common.loadDataTable(this.benHistory, '#tablevitals');
      // }
      // this.benHistoryRef = res.data[0];
      this.selectedData=res.data.ehrReport.length>0 ? res.data.ehrReport[0] : this.getUserData(id);;
      this.profile_photo= res.data.ehrReport.length>0 ?res.data.ehrReport[0].photo_path :' ';
      // this.ehrhistory=res.data.ehrReport;
      let ehrhistory=[];
      // res.data.ehrReport.map(resp=>{
      //   if(this.docData){
      //     if(resp.doctor_id==this.docData.id){
      //    ehrhistory.push(resp);
      //   }
      //   }
       
      //  })
      //  this.ehrhistory=ehrhistory;
       this.ehrhistory= res.data.ehrReport;
   // this.ehrhistory=this.ehrhistory.map((r=>{
        // let bmi = r.weight/r.height*r.height;
        // if(bmi<18.5){
        // r.bmi='Under Weight';
        // } if(bmi>=18.5 && bmi<=24.9){
        //   r.bmi='Normal';
        // } if(bmi>=25 && bmi<=29.9){
        //   r.bmi='Over Weight';
        // }if(bmi>=30.0){
        //   r.bmi='Very Over Weight'
        // }
      //   for(let i=0;i<this.documentHistory.length;i++){
      //     if(r.beneficiary_id ==this.documentHistory[i].beneficiary_id && r.visit_date == this.documentHistory[i].visit_date){
      //      r.prescription=this.documentHistory[i].lab_report;
      //     }
      //    }
      // }
      //   ))
      for(let i=0;i<this.ehrhistory.length;i++){
        for(let j=0;j<this.documentHistory.length;j++){
              if(this.ehrhistory[i].beneficiary_id ==this.documentHistory[j].beneficiary_id && this.ehrhistory[i].visit_date == this.documentHistory[j].visit_date){
                this.ehrhistory[i].prescription=this.documentHistory[j].lab_report;
              }
      }
    }
        this.vitalList=res.data.vitalReport;
        this.vitalList.map((res=>{
          let ht= (res.height/100)*(res.height/100);
          let bmi = res.weight/ht;
          if(bmi<18.5){
          res.bmi='Under Weight';
          } if(bmi>=18.5 && bmi<=24.9){
            res.bmi='Normal';
          } if(bmi>=25 && bmi<=29.9){
            res.bmi='Over Weight';
          }if(bmi>=30.0){
            res.bmi='Very Over Weight'
          }
         
        }
          ))
      //Common.loadDataTable(this.ehrhistory, '#tablevitals');
      setTimeout(() => {
        this.bindData();
      }, 1000);
     
      // res.data.forEach(e => {
      //   let temp = e.beneficiary_visit_files;
      //   let resDgns = e.diagnosis.provisionalDiagnosis;
      //   var doc_id = e.doctor_id.id;
      //   //Object.keys(e)
      //   if (Object.keys(e).includes('prescribed_medications')) {
      //     e.prescribed_medications['doc_id'] = doc_id;
      //   }
      //   // let isStr = (typeof e.diagnosis?.provisionalDiagnois == 'string');
      //   if (resDgns.length > 0) {
      //     resDgns.forEach(rd => {
      //       this.lstbenHstry.push({ visit_date: e.visit_date, docCmnt: e.advice.doctorComment, dgns: rd?.diagnosis_name, document_path: temp });
      //     });
      //   }
      // });
    }, err => { this.toastr.error(err) });

    this.getBenVitalDetails(id);
  }
  openWindow(poc_file){
    window.open(poc_file, '_blank', 'left=300,top=50,width=700,height=600,toolbar=1,resizable=0');
    
  }
  bindData(){
    if(this.selectedData){
        this.ehrFormRpt.patchValue({
     abhaid:this.selectedData.health_id || '',
     state:this.selectedData.state_name || '',
     district:this.selectedData.district_name || '',
     centername:this.selectedData.center_name || '',
     name:this.selectedData.dependent_id && this.selectedData.dependent_id!==null && this.selectedData.dependent_id!==''?this.selectedData.dependent_name:this.selectedData.beneficiary_name || '',
     gender:this.selectedData.gender || '',
     age:this.selectedData.age || '',
     mobile:this.selectedData.mobile || '',
     maritalStatus:this.selectedData.marital_status || ''
    })
    }
    
  }
  isChngPrintOnlyUpdated(){
  this.isPrintOnlyUpdated = !this.isPrintOnlyUpdated;
  }
  printEhr(){
    window.print();
  }
 
  closeEhr(){

  }

  onBack() {
    //sushma 08-07-2022 hide back button
   let data = JSON.parse(localStorage.getItem('ehrback'));
   if(data==true)
   {
    // this.ehrBack = true;
    this.router.navigate(['home/patientList']);
   }
   
    // else if (id ==2 && this.roleId==7 || this.roleId==2){
    else {  
      // this.ehrBack = false;
      const modalRef = this.modalService.open(FamilyMemberRegistrationComponent, { scrollable: true, size: 'xl' });
     // console.log(modalRef);
      // modalRef.componentInstance.
    }
    // else{
    //   this.router.navigate(['home/patientList']);
    // }
  }
  onBacktoList(){
     window.history.back();
     if(localStorage.ehrbackCamp) {
      this.active.queryParams.subscribe((res: any) => {
      this.router.navigate(['/home/consultation/mmupatientList'],{queryParams: { camp_id: res.camp_id}});
      localStorage.removeItem('ehrbackCamp');
      localStorage.removeItem('ehrback');
    });
    
 // fallback route if no history
  }else if(localStorage.ehrback){
    this.router.navigate(['/home/consultation/patientlist']);
     localStorage.removeItem('ehrback'); 
     localStorage.removeItem('ehrbackCamp');
  }
  else  {
    window.history.back();
     localStorage.removeItem('ehrback');
    localStorage.removeItem('ehrbackCamp');  // same as window.history.back()
  } 
  }

  getUserData(id:any){
    let apiPath:any
    let isSelf=false
    if(sessionStorage.getItem('is_self_ehr')==='1'){
      apiPath= `beneficiaryId=${id}` 
      isSelf=true
    }else{
       apiPath= `memberId=${id}`
       isSelf=false
    }
 
     this.registrationService.get(`registration/jwt/beneficiary/getbeneficiaryrecordbyid?${apiPath}`).subscribe({
          next: res => {
            if (res.status == 'OK') {
              this.selectedData = res.data??[]
              this.selectedData.beneficiary_name = ''
              this.selectedData.gender = this.selectedData.gender_id == '1'?'Male': this.selectedData.gender_id == '2'?'Female':'Transgender'
              if(isSelf){
                 this.selectedData.dependent_id = ''
                this.selectedData.beneficiary_name = this.selectedData?.first_name + ''+ this.selectedData.middle_name +'' + this.selectedData.last_name || ''
              }else{
              this.selectedData.dependent_name = this.selectedData?.member_name
              this.selectedData.dependent_id = this.selectedData?.id

              }
              return   this.selectedData
    
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
    
          },
          complete: () => {
            // Any additional logic after patching values
          },
        });
  }
}
